const justunoPurchase = ({
    number,
    items: orderItems,
    total: {
        discounts,
        total_shipping,
        grand_total,
        total_tax,
        subtotal,
    }
}) => {
    let discount = 0;

    discounts?.forEach(({ amount: { value } }) => {
        discount = discount + value * 100;
    });

    const cartItems = orderItems.map(({
        product: { name, sku },
        quantity_ordered,
        product_sale_price: { value },
    }) => ({
        productID: sku, // required
        variationID: sku, // required
        sku, // required
        name, // required
        qty: quantity_ordered, // required
        price: value * 100, // required in cents $100 = 10000
    }));

    window.ju4app('order', {
        orderID: number, // required, must be unique per order
        grandTotal: grand_total.value * 100, // required in cents $100 = 10000
        subTotal: subtotal.value * 100, // required in cents $100 = 10000
        tax: total_tax.value * 100, // required in cents $100 = 10000
        shipping: total_shipping.value * 100, // required in cents $100 = 10000
        discount: discount, // required in cents $100 = 10000
        currency: grand_total.currency, // required example 'USD'
        cartItems,
    });
};

const justunoUpdateCart = ({
   id,
   itemsV2: { items },
   prices: {
       grand_total,
       subtotal_excluding_tax,
   }
}) => {
    window.ju4app('cartSync', {
        items: items.map(({
            product: {
                name,
                sku,
                price_range: {
                    minimum_price: {
                        regular_price,
                        discount: { amount_off },
                    }
                }
            },
            quantity,
        }) => ({
            productID: sku, // required
            variationID: sku, // required
            sku, // required
            price: regular_price.value * 100, // required in cents $100 = 10000
            qty: quantity, // required
            name, // required
            discount: amount_off * 100, // required in cents $100 = 10000
        })),
        cart: {
            currency: grand_total.currency, // optional
            cartID: id, // optional
            subTotal: subtotal_excluding_tax.value * 100, // optional in cents $100 = 10000
            totalPrice: grand_total.value * 100, // optional in cents $100 = 10000
        },
    });
};

const justunoLoad = () => {
    window.ju4app=window.ju4app||function(){(window.ju4app.q=window.ju4app.q||[]).push(arguments)};
};

export {
    justunoLoad,
    justunoPurchase,
    justunoUpdateCart,
};
